import styled from 'styled-components';

import { RadiusConfig, neutral, neutralTrans } from 'enable-ui';

import { COLOR_CONFIG } from 'constants/color';

export const ActionBtnDelete = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: ${RadiusConfig.xxs}px;
  background-color: ${neutral['neutral-1']};
  border: 1px solid ${neutralTrans['neutralTrans-15']};
  cursor: pointer;
`;

export const ThumbnailCompContainer = styled.div`
  .es-file-upload {
    background-color: ${COLOR_CONFIG.white};

    p {
      font-size: 16px;
      line-height: 22px;
      color: ${COLOR_CONFIG['neutral-text']};
    }
  }

  svg {
    path {
      stroke: ${COLOR_CONFIG['neutral-text']} !important;
    }
  }
`;
